/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { MappingRule } from "./MappingRule";
export const MappingRulesResponse = core.serialization.object({
    data: core.serialization.list(MappingRule),
});
